import { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../utils/api';

export function useWanData(selectedDevice, selectedInterval, customRange = { start: '', end: '' }) {
    const [wanData, setWanData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [lastUpdated, setLastUpdated] = useState(null);

    const fetchWanData = useCallback(async () => {
        if (!selectedDevice || !selectedInterval) {
            setWanData(null);
            setLastUpdated(null);
            return;
        }

        if (selectedInterval === 'custom') {
            if (!customRange?.start || !customRange?.end) {
                setWanData(null);
                setLastUpdated(null);
                return;
            }
        }

        try {
            setLoading(true);
            setError(null);
            const extraParams =
                selectedInterval === 'custom' && customRange?.start && customRange?.end
                    ? { dt_start: customRange.start, dt_end: customRange.end }
                    : undefined;
            const data = await apiClient.getWanData(selectedDevice, selectedInterval, extraParams);
            setWanData(data ?? {});
            setLastUpdated(new Date());
        } catch (err) {
            console.error('Error fetching WAN data:', err);
            if (err?.status === 403) {
                setError('You do not have permission to view WAN metrics.');
            } else if (err?.status === 401) {
                setError('Session expired. Please sign in again.');
            } else {
                setError(err.message || 'Unknown error');
            }
            setWanData(null);
            setLastUpdated(null);
        } finally {
            setLoading(false);
        }
    }, [selectedDevice, selectedInterval, customRange?.start, customRange?.end]);

    useEffect(() => {
        fetchWanData();
    }, [fetchWanData]);

    return {
        wanData,
        loading,
        error,
        lastUpdated,
        refresh: fetchWanData,
    };
}
